import React, { useState, useEffect } from 'react';
import UDITextField from "./UDITextField.js";

const MaximumNumberOfReuses = ({
	UDI,
	setUDI,
	forceIsEditing = null,
	auxFieldName
}) => {

	const [errorVar, setErrorVar] = useState(false);

	const fieldName = "MaximumNumberOfReuses";
	const fieldTitle = "Maximum Number Of Reuses";


	const isNullOrEmpty = (val) => {
        return val === "" || val === null;
    }

	const validate = () => {

        setErrorVar(false);

        const value = UDI[fieldName];
        const singleUse = String(UDI[auxFieldName]);

        if (value === undefined || isNullOrEmpty(value)) {
			setErrorVar(fieldTitle + " is mandatory");
			return false;
        }

        if (singleUse === "true" && Number(value) !== 0) {
			setErrorVar(fieldTitle + " must be 0 when 'Labelled as Single Use' is set to 'Yes'");
			return false;
        }

        if (singleUse === "false" && (isNullOrEmpty(value) || !Number.isInteger(Number(value)) || (Number(value) <= 0 && Number(value) !== -1))) {
			setErrorVar(fieldTitle + " must be a positive number, or -1 if not defined, when 'Labelled as Single Use' is set to 'No'");
			return false;
        }
    }


	useEffect(() => {

        validate();

	}, [UDI]);


	return <>
		<UDITextField UDI={UDI} setUDI={setUDI} fieldTitle={fieldTitle} fieldName={fieldName} numeric={true} forceIsEditing={forceIsEditing} />

		{errorVar && (
			<div className="view-task-field">
				<div className="view-task-field-line">
					<div className="view-task-field-title"></div>
					<div className="view-task-field-value">
						<span className="form-field-error-message">
							{errorVar}
						</span>
					</div>
				</div>
			</div>
		)}

	</>											  
}


export default MaximumNumberOfReuses;


